import { MapSettings, SortValue } from '@app/modules/client/map/shared/models/map-settings.model'
import { MapType } from '@app/modules/client/map/shared/models/map.type'

export const mapSettings: MapSettings = {
  mapControls: {
    areClusters: false,
    areAllGroupsSelected: false,
    isMapTrafficLayer: false,
    isMapMarkerTooltipShown: true,
    isZoomToRoute: true,
    isSearchByMap: false,
    isCenterVehicle: false,
    mapType: MapType.Streets,
    selectedGeofencesGroupIds: [],
  },
  sidebar: {
    filters: {},
    tabIndex: 0,
    sortValue: SortValue.VehicleTitle,
    selectedStatus: null,
  },
}
